(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-linesheet"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-linesheet-download]');
    if (!button) return;

    const linesheet = button.closest('[data-linesheet]');
    const images = Array.from(linesheet.querySelectorAll('img'));

    await Promise.allSettled(
      images.map((image) => {
        if (!image.complete) {
          return new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        }
        if (image.decode) return image.decode();
        return Promise.resolve();
      })
    );

    window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wholesale-collection')) {
    customElements.define(
      'wholesale-collection',
      class WholesaleCollection extends HTMLElement {
        connectedCallback() {
          this.openButton = null;
          this.viewerTrigger = null;
          const disableRebuyAutoOpen = () => {
            if (window.Rebuy?.SmartCart) {
              window.Rebuy.SmartCart.skip_open = true;
            }
          };
          disableRebuyAutoOpen();
          document.addEventListener('rebuy:smartcart.ready', disableRebuyAutoOpen, { once: true });
          this.addEventListener('click', this.handleClick.bind(this));
          this.addEventListener('input', this.handleInput.bind(this));
          this.addEventListener('pointerdown', this.startImagePan.bind(this));
          this.addEventListener('pointermove', this.moveImagePan.bind(this));
          this.addEventListener('pointerup', this.endImagePan.bind(this));
          this.addEventListener('pointercancel', this.endImagePan.bind(this));
          this.querySelectorAll('dialog').forEach((dialog) => {
            dialog.addEventListener('click', (event) => {
              if (event.target !== dialog) return;
              if (dialog.matches('[data-wholesale-viewer]')) dialog.close();
              else this.closeDialog(dialog);
            });
            dialog.addEventListener('close', () => {
              if (dialog.matches('[data-wholesale-viewer]')) {
                if (this.viewerTrigger?.isConnected) this.viewerTrigger.focus();
                this.viewerTrigger = null;
                return;
              }
              this.resetDialog(dialog, false);
              if (this.openButton) this.openButton.focus();
            });
          });
        }

        transition(callback) {
          if (document.startViewTransition) {
            document.startViewTransition(callback);
          } else {
            callback();
          }
        }

        handleClick(event) {
          const galleryOpen = event.target.closest('[data-wholesale-gallery-open]');
          const viewerCloseButton = event.target.closest('[data-wholesale-viewer-close]');
          const viewerPreviousButton = event.target.closest('[data-wholesale-viewer-previous]');
          const viewerNextButton = event.target.closest('[data-wholesale-viewer-next]');
          const openButton = event.target.closest('[data-wholesale-open]');
          const closeButton = event.target.closest('[data-wholesale-close]');
          const galleryThumbnail = event.target.closest('[data-wholesale-gallery-thumbnail]');
          const quantityButton = event.target.closest('[data-quantity-action]');
          const submitButton = event.target.closest('[data-wholesale-submit]');

          if (galleryOpen) {
            this.openViewer(galleryOpen);
            return;
          }

          if (viewerCloseButton) {
            viewerCloseButton.closest('[data-wholesale-viewer]')?.close();
            return;
          }

          if (viewerPreviousButton || viewerNextButton) {
            this.stepViewer(viewerPreviousButton || viewerNextButton, viewerPreviousButton ? -1 : 1);
            return;
          }

          if (openButton) {
            const dialog = this.querySelector(`#${CSS.escape(openButton.getAttribute('aria-controls'))}`);
            if (!dialog) return;
            this.openButton = openButton;
            this.resetDialog(dialog, true);
            dialog.showModal();
            return;
          }

          if (closeButton) {
            this.closeDialog(closeButton.closest('dialog'));
            return;
          }

          if (galleryThumbnail) {
            this.setGalleryImage(galleryThumbnail.closest('[data-wholesale-gallery]'), galleryThumbnail);
            return;
          }

          if (quantityButton) {
            const control = quantityButton.closest('[data-quantity-control]');
            const input = control.querySelector('[data-wholesale-quantity]');
            const change = quantityButton.dataset.quantityAction === 'increase' ? 1 : -1;
            input.value = Math.max(0, Number(input.value || 0) + change);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            return;
          }

          if (submitButton) {
            this.addSelected(submitButton.closest('dialog'));
            return;
          }
        }

        startImagePan(event) {
          const image = event.target.closest('[data-wholesale-viewer-image]');
          const frame = image?.closest('[data-wholesale-viewer-frame]');
          if (!frame || event.button !== 0 || event.pointerType === 'touch' || frame.scrollHeight <= frame.clientHeight) return;

          event.preventDefault();
          this.imagePan = {
            frame,
            pointerId: event.pointerId,
            startY: event.clientY,
            startScrollTop: frame.scrollTop
          };
          frame.classList.add('is-panning');
          frame.setPointerCapture(event.pointerId);
        }

        moveImagePan(event) {
          if (!this.imagePan || event.pointerId !== this.imagePan.pointerId) return;
          this.imagePan.frame.scrollTop = this.imagePan.startScrollTop - (event.clientY - this.imagePan.startY);
        }

        endImagePan(event) {
          if (!this.imagePan || event.pointerId !== this.imagePan.pointerId) return;

          const frame = this.imagePan.frame;
          frame.classList.remove('is-panning');
          if (frame.hasPointerCapture(event.pointerId)) frame.releasePointerCapture(event.pointerId);
          this.imagePan = null;
        }

        openViewer(trigger) {
          const gallery = trigger.closest('[data-wholesale-gallery]');
          const viewer = gallery?.querySelector('[data-wholesale-viewer]');
          const thumbnails = gallery ? [...gallery.querySelectorAll('[data-wholesale-gallery-thumbnail]')] : [];
          if (!gallery || !viewer || !thumbnails.length) return;

          let index = thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true');
          if (index < 0) index = 0;

          this.viewerTrigger = trigger;
          this.setViewerImage(viewer, thumbnails, index);
          if (!viewer.open) viewer.showModal();
          viewer.querySelector('[data-wholesale-viewer-close]')?.focus();
        }

        stepViewer(button, direction) {
          const viewer = button.closest('[data-wholesale-viewer]');
          const gallery = viewer?.closest('[data-wholesale-gallery]');
          const thumbnails = gallery ? [...gallery.querySelectorAll('[data-wholesale-gallery-thumbnail]')] : [];
          if (!viewer || !thumbnails.length) return;

          const index = Number(viewer.dataset.imageIndex || 0) + direction;
          this.setViewerImage(viewer, thumbnails, index);
        }

        setViewerImage(viewer, thumbnails, index) {
          const length = thumbnails.length;
          if (!length) return;

          const selectedIndex = (index + length) % length;
          const selected = thumbnails[selectedIndex];
          const image = viewer.querySelector('[data-wholesale-viewer-image]');
          if (!image) return;

          image.src = selected.dataset.imageFull || selected.dataset.imageSrc;
          image.alt = selected.dataset.imageAlt || '';
          viewer.dataset.imageIndex = String(selectedIndex);

          const status = viewer.querySelector('[data-wholesale-viewer-status]');
          if (status) status.textContent = selected.getAttribute('aria-label') || '';

          const frame = viewer.querySelector('[data-wholesale-viewer-frame]');
          if (frame) {
            frame.scrollTop = 0;
            frame.setAttribute('aria-label', selected.getAttribute('aria-label') || '');
          }

          const previous = viewer.querySelector('[data-wholesale-viewer-previous]');
          const next = viewer.querySelector('[data-wholesale-viewer-next]');
          if (previous) previous.hidden = length < 2;
          if (next) next.hidden = length < 2;

          this.setGalleryImage(viewer.closest('[data-wholesale-gallery]'), selected);
        }

        setGalleryImage(gallery, selected) {
          if (!gallery || !selected) return;

          const hero = gallery.querySelector('[data-wholesale-gallery-image]');
          const heroButton = gallery.querySelector('[data-wholesale-gallery-open]');
          if (!hero || !heroButton) return;

          this.transition(() => {
            hero.src = selected.dataset.imageSrc;
            hero.srcset = selected.dataset.imageSrcset;
            hero.alt = selected.dataset.imageAlt;
            heroButton.setAttribute('aria-label', selected.getAttribute('aria-label') || '');
            gallery.querySelectorAll('[data-wholesale-gallery-thumbnail]').forEach((thumbnail) => {
              thumbnail.setAttribute('aria-current', String(thumbnail === selected));
            });
          });
        }

        handleInput(event) {
          if (!event.target.matches('[data-wholesale-quantity]')) return;
          event.target.value = Math.max(0, Math.floor(Number(event.target.value || 0)));
          this.updateSummary(event.target.closest('dialog'));
        }

        updateSummary(dialog) {
          const quantities = [...dialog.querySelectorAll('[data-wholesale-quantity]')];
          const totals = quantities.reduce(
            (summary, input) => {
              const quantity = Number(input.value || 0);
              summary.units += quantity;
              summary.total += quantity * Number(input.dataset.price || 0);
              return summary;
            },
            { units: 0, total: 0 }
          );
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: dialog.dataset.currency
          }).format(totals.total / 100);
          dialog.querySelector('[data-wholesale-units]').textContent = totals.units;
          dialog.querySelector('[data-wholesale-total]').textContent = money;
          dialog.querySelector('[data-wholesale-submit]').disabled = totals.units === 0;
          dialog.querySelector('[data-wholesale-message]').textContent = '';
        }

        async addSelected(dialog) {
          const inputs = [...dialog.querySelectorAll('[data-wholesale-quantity]')];
          const selected = inputs.filter((input) => Number(input.value || 0) > 0);
          const message = dialog.querySelector('[data-wholesale-message]');
          const submit = dialog.querySelector('[data-wholesale-submit]');

          if (!selected.length) {
            message.textContent = this.dataset.emptyError;
            return;
          }

          const items = selected.map((input) => ({
            id: Number(input.dataset.variantId),
            quantity: Number(input.value)
          }));
          const unitCount = items.reduce((sum, item) => sum + item.quantity, 0);

          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items })
            });
            const result = await response.json();

            if (!response.ok || result.status) {
              throw new Error(result.description || result.message || this.dataset.generalError);
            }

            const cartResponse = await fetch(this.dataset.cartUrl, {
              headers: { Accept: 'application/json' }
            });
            const cart = await cartResponse.json();
            document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: { cart }
              })
            );

            const successDetail = this.dataset.successTemplate
              .replace('__units__', unitCount)
              .replace('__sizes__', selected.length);
            dialog.querySelector('[data-wholesale-success-detail]').textContent = successDetail;

            this.transition(() => {
              dialog.querySelector('[data-wholesale-form]').hidden = true;
              dialog.querySelector('[data-wholesale-success]').hidden = false;
            });

            inputs.forEach((input) => {
              input.value = 0;
            });
          } catch (error) {
            message.textContent = error.message || this.dataset.generalError;
            submit.disabled = false;
          } finally {
            submit.removeAttribute('aria-busy');
          }
        }

        openNext(dialog) {
          const buttons = [...this.querySelectorAll('[data-wholesale-open]')];
          const currentIndex = buttons.indexOf(this.openButton);
          const nextButton = buttons[currentIndex + 1];
          this.closeDialog(dialog, false);
          if (nextButton) {
            nextButton.click();
          } else {
            buttons[0]?.focus();
          }
        }

        closeDialog(dialog, restoreFocus = true) {
          if (!dialog) return;
          dialog.close();
          if (!restoreFocus) this.openButton = null;
        }

        resetDialog(dialog, updateSummary) {
          dialog.querySelector('[data-wholesale-form]').hidden = false;
          dialog.querySelector('[data-wholesale-success]').hidden = true;
          dialog.querySelector('[data-wholesale-message]').textContent = '';
          if (updateSummary) this.updateSummary(dialog);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-dynamic-bulk-order"] && !Shopify.designMode) return;
  try {
    
  class BulkOrderForm {
    constructor(root) {
      this.root = root;
      this.currency = root.dataset.currency || 'USD';
      this.cartUrl = root.dataset.cartUrl || '/cart';
      this.inputs = Array.from(
        root.querySelectorAll('[data-bulk-order-quantity]')
      );
      this.rows = Array.from(
        root.querySelectorAll('[data-bulk-order-row]')
      );
      this.categories = Array.from(
        root.querySelectorAll('[data-bulk-order-category]')
      );
      this.submitButton = root.querySelector('[data-bulk-order-submit]');
      this.unitsOutput = root.querySelector('[data-bulk-order-units]');
      this.skusOutput = root.querySelector('[data-bulk-order-skus]');
      this.totalOutput = root.querySelector('[data-bulk-order-total]');
      this.message = root.querySelector('[data-bulk-order-message]');
      this.search = root.querySelector('[data-bulk-order-search]');
      this.imageToggle = root.querySelector(
        '[data-bulk-order-image-toggle]'
      );
      this.noResults = root.querySelector(
        '[data-bulk-order-no-results]'
      );

      this.formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: this.currency,
      });

      this.bindEvents();
      this.update();
      this.updateImageVisibility();
    }

    bindEvents() {
      this.root.addEventListener('input', (event) => {
        const input = event.target.closest(
          '[data-bulk-order-quantity]'
        );

        if (!input) return;

        this.normalizeInput(input);
        this.update();
      });

      this.root.addEventListener('change', (event) => {
        const input = event.target.closest(
          '[data-bulk-order-quantity]'
        );

        if (!input) return;

        this.normalizeInput(input);
        this.update();
      });

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => {
          this.submit();
        });
      }

      if (this.search) {
        this.search.addEventListener('input', () => {
          this.filterRows();
        });
      }

      if (this.imageToggle) {
        this.imageToggle.addEventListener('change', () => {
          this.updateImageVisibility();
        });
      }
    }

    normalizeInput(input) {
      const parsed = Number.parseInt(input.value, 10);

      if (!Number.isFinite(parsed) || parsed < 1) {
        input.value = '';
        return;
      }

      input.value = String(parsed);
    }

    getSelectedItems() {
      return this.inputs
        .map((input) => {
          const quantity = Number.parseInt(input.value, 10) || 0;
          const variantId = Number.parseInt(
            input.dataset.variantId,
            10
          );
          const price = Number.parseInt(input.dataset.price, 10) || 0;

          return {
            input,
            variantId,
            quantity,
            price,
          };
        })
        .filter((item) => {
          return (
            item.quantity > 0 &&
            Number.isFinite(item.variantId) &&
            !item.input.disabled
          );
        });
    }

    update() {
      const selectedItems = this.getSelectedItems();

      const totals = selectedItems.reduce(
        (summary, item) => {
          summary.units += item.quantity;
          summary.total += item.quantity * item.price;
          return summary;
        },
        {
          units: 0,
          total: 0,
        }
      );

      this.rows.forEach((row) => {
        const rowInputs = Array.from(
          row.querySelectorAll('[data-bulk-order-quantity]')
        );

        const rowTotal = rowInputs.reduce((total, input) => {
          const quantity = Number.parseInt(input.value, 10) || 0;
          const price = Number.parseInt(input.dataset.price, 10) || 0;
          return total + quantity * price;
        }, 0);

        const rowOutput = row.querySelector(
          '[data-bulk-order-row-total]'
        );

        if (rowOutput) {
          rowOutput.textContent = this.formatMoney(rowTotal);
        }

        row.classList.toggle(
          'bulk-order-row--selected',
          rowTotal > 0
        );
      });

      if (this.skusOutput) {
        this.skusOutput.textContent = String(selectedItems.length);
      }

      if (this.unitsOutput) {
        this.unitsOutput.textContent = String(totals.units);
      }

      if (this.totalOutput) {
        this.totalOutput.textContent = this.formatMoney(totals.total);
      }

      if (this.submitButton) {
        this.submitButton.disabled = selectedItems.length === 0;
      }

      this.setMessage('');
    }

    formatMoney(cents) {
      return this.formatter.format(cents / 100);
    }

    setMessage(message, isError = false) {
      if (!this.message) return;

      this.message.textContent = message;
      this.message.classList.toggle(
        'bulk-order__message--error',
        Boolean(message && isError)
      );
    }

    filterRows() {
      const query = (this.search.value || '')
        .trim()
        .toLowerCase();

      let visibleRows = 0;

      this.rows.forEach((row) => {
        const searchText = (
          row.dataset.searchText ||
          row.textContent ||
          ''
        ).toLowerCase();

        const isVisible =
          query.length === 0 || searchText.includes(query);

        row.hidden = !isVisible;

        if (isVisible) {
          visibleRows += 1;
        }
      });

      this.categories.forEach((category) => {
        const hasVisibleRows = Array.from(
          category.querySelectorAll('[data-bulk-order-row]')
        ).some((row) => !row.hidden);

        category.hidden = !hasVisibleRows;
      });

      if (this.noResults) {
        this.noResults.hidden = visibleRows !== 0;
      }
    }

    updateImageVisibility() {
      if (!this.imageToggle) return;

      this.root.classList.toggle(
        'bulk-order--hide-images',
        !this.imageToggle.checked
      );
    }

    async submit() {
      const selectedItems = this.getSelectedItems();

      if (!selectedItems.length || !this.submitButton) return;

      this.submitButton.disabled = true;
      this.submitButton.setAttribute('aria-busy', 'true');

      const originalLabel = this.submitButton.textContent;
      this.submitButton.textContent = 'Adding items…';
      this.setMessage('');

      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/add.js`,
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: selectedItems.map((item) => ({
                id: item.variantId,
                quantity: item.quantity,
              })),
            }),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'The selected items could not be added.'
          );
        }

        const totalUnits = selectedItems.reduce(
          (total, item) => total + item.quantity,
          0
        );

        this.setMessage(
          `${totalUnits} units were added to your cart.`
        );

        window.location.assign(this.cartUrl);
      } catch (error) {
        console.error('Bulk order add-to-cart failed', error);

        this.setMessage(
          error.message ||
            'Sorry, the selected items could not be added. Please try again.',
          true
        );

        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-busy');
        this.submitButton.textContent = originalLabel;
      }
    }
  }

  function initializeBulkOrderForms(scope = document) {
    scope
      .querySelectorAll('[data-bulk-order]')
      .forEach((root) => {
        if (root.dataset.bulkOrderInitialized === 'true') return;

        root.dataset.bulkOrderInitialized = 'true';
        new BulkOrderForm(root);
      });
  }

  initializeBulkOrderForms();

  document.addEventListener('shopify:section:load', (event) => {
    initializeBulkOrderForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-dynamic-linesheet"] && !Shopify.designMode) return;
  try {
    
  function sanitizeLinesheetFilename(name) {
    var cleaned = (name || 'Linesheet').replace(/[\\/:*?"<>|]+/g, '').trim();
    return cleaned.length ? cleaned : 'Linesheet';
  }

  function ensureHtml2Pdf(src) {
    if (window.html2pdf) return Promise.resolve();
    if (!src) return Promise.reject(new Error('Missing html2pdf source URL'));

    if (!ensureHtml2Pdf.promise) {
      ensureHtml2Pdf.promise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => reject(new Error('Failed to load html2pdf')));
        document.head.appendChild(script);
      });
    }

    return ensureHtml2Pdf.promise;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-linesheet-download]');
    if (!button) return;

    const linesheet = button.closest('[data-linesheet]');
    const documentToPrint = linesheet.querySelector('.linesheet__document');
    if (!documentToPrint) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Preparing PDF…';

    let pdfRoot;

    try {
      await ensureHtml2Pdf(linesheet.dataset.linesheetPdfSrc);

    const images = Array.from(documentToPrint.querySelectorAll('img'));
      await Promise.allSettled(
        images.map((image) => {
          if (!image.complete) {
            return new Promise((resolve) => {
              image.addEventListener('load', resolve, { once: true });
              image.addEventListener('error', resolve, { once: true });
            });
          }
          if (image.decode) return image.decode().catch(() => {});
          return Promise.resolve();
        })
      );

      const documentClone = documentToPrint.cloneNode(true);
      documentClone.querySelectorAll('.linesheet__pagination').forEach((node) => node.remove());

            const pdfHeader = document.createElement('div');
      pdfHeader.className = 'linesheet__pdf-header';

      const logoSourceEl = document.querySelector('.header__logo--image');
      const svgLogoEl = logoSourceEl ? logoSourceEl.querySelector('svg') : null;
      const imgLogoEl = logoSourceEl ? logoSourceEl.querySelector('img') : null;

      let logoNode = null;
      if (svgLogoEl) {
        logoNode = svgLogoEl.cloneNode(true);
      } else if (imgLogoEl) {
        logoNode = document.createElement('img');
        logoNode.src = imgLogoEl.currentSrc || imgLogoEl.src;
        logoNode.alt = '';
      }

      if (logoNode) {
        logoNode.removeAttribute('width');
        logoNode.removeAttribute('height');
        logoNode.removeAttribute('class');
        logoNode.classList.add('linesheet__pdf-header-logo');
        logoNode.style.position = 'static';
        logoNode.style.top = 'auto';
        logoNode.style.left = 'auto';
        logoNode.style.transform = 'none';
        logoNode.style.float = 'none';
        pdfHeader.appendChild(logoNode);
      }

      const pdfHeaderTitle = document.createElement('p');
      pdfHeaderTitle.className = 'linesheet__pdf-header-title';
      pdfHeaderTitle.textContent = linesheet.dataset.linesheetFilename || '';
      pdfHeader.appendChild(pdfHeaderTitle);

      documentClone.insertBefore(pdfHeader, documentClone.firstChild);

      const linesheetStyles = getComputedStyle(linesheet);
      const resolvedColumns = parseInt(linesheetStyles.getPropertyValue('--linesheet-columns'), 10) || 4;
      const resolvedImageRatio = linesheetStyles.getPropertyValue('--linesheet-image-ratio').trim() || '1';
      const resolvedImageFit = linesheetStyles.getPropertyValue('--linesheet-image-fit').trim() || 'contain';

      documentClone.querySelectorAll('.linesheet__grid').forEach((grid) => {
        const gridGap = getComputedStyle(grid).gap || '0.08in';
        const cards = Array.from(grid.children);
        grid.style.display = 'block';
        for (let i = 0; i < cards.length; i += resolvedColumns) {
          const row = document.createElement('div');
          row.style.display = 'grid';
          row.style.gridTemplateColumns = `repeat(${resolvedColumns}, minmax(0, 1fr))`;
          row.style.gap = gridGap;
          row.style.breakInside = 'avoid';
          row.style.pageBreakInside = 'avoid';
          cards.slice(i, i + resolvedColumns).forEach((card) => row.appendChild(card));
          grid.appendChild(row);
        }
      });

      documentClone.querySelectorAll('.linesheet-card__media').forEach((media) => {
        media.style.aspectRatio = `1 / ${resolvedImageRatio}`;
      });
      documentClone.querySelectorAll('.linesheet-card__image, .linesheet-card__placeholder').forEach((img) => {
        img.style.objectFit = resolvedImageFit;
      });

      pdfRoot = document.createElement('div');
      pdfRoot.className = 'linesheet linesheet-pdf-export';
      pdfRoot.setAttribute(
        'style',
        (linesheet.getAttribute('style') || '') +
          '; position: fixed; inset: 0; z-index: 999999; overflow: auto; background: #fff; padding: 24px 0; min-height: 0;'
      );
      pdfRoot.appendChild(documentClone);
      document.body.appendChild(pdfRoot);

      const filename = sanitizeLinesheetFilename(linesheet.dataset.linesheetFilename) + ' Linesheet.pdf';

      await window.html2pdf()
        .set({
          margin: [0.35, 0.33, 0.32, 0.33],
          filename,
          image: { type: 'jpeg', quality: 0.95 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff',
          },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
          pagebreak: { mode: ['avoid-all'] },
        })
        .from(documentClone)
        .save();
    } catch (error) {
      console.error('Linesheet PDF generation failed', error);
      window.alert('Sorry, the linesheet PDF could not be generated. Please try again.');
    } finally {
      if (pdfRoot) pdfRoot.remove();
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
